<script setup lang="ts">
import type {PricingPlanProps} from "@nuxt/ui";
import { defu } from 'defu'

const props = defineProps<{
  only ?: string[],
  period ?: string,
  plans ?: PricingPlanProps[],
}>()

const benevoltDomain = useDomain()
const userAuth = useCookie('auth_token', { readonly: true })
const { data: subscription } = await useFetch(`https://espaceasso.${benevoltDomain}/api/subscription-plans`,{
  query: {
    period: props.period,
  },
  transform: (s) => {
    s.plans = s.plans.map((p) => {
      p.button = p.button && (p.id != 'free' || !userAuth.value) ? {...p.button, to: userAuth.value ? `https://www.${benevoltDomain}/organization/subscription#subscribe` : `https://espaceasso.${benevoltDomain}/login`} : null
      const data = props.plans?.find((i) => i.id === p.id) || {}
      return defu(data, p)
    })
    s.table.tiers = s.table.tiers.map((p) => {
      p.button = p.button && (p.id != 'free' || !userAuth.value) ? {...p.button, to: userAuth.value ? `https://www.${benevoltDomain}/organization/subscription#subscribe` : `https://espaceasso.${benevoltDomain}/login`} : null
      const data = props.plans?.find((i) => i.id === p.id) || {}
      return defu(data, p)
    })
    return s
  }
})

function copy(code) {
  useClipboard().copy(code)
  useToast().add({
    title: 'Le code a été copié dans votre Presse-papiers',
    icon: 'i-ph-check-circle-duotone',
  })
}
</script>

<template>
  <UPricingPlans compact>
    <UPricingPlan
        v-for="(plan, index) in subscription?.plans.filter((p) => props.only ? props.only.includes(p.id) : true)"
        :key="index"
        v-bind="plan"
        :ui="{featureTitle: 'text-ellipsis', tagline: 'font-normal'}"
    >
      <template #tagline v-if="plan.coupon">
        <div class="flex flex-col items-center text-muted">
          <p class="mt-8 font-bold">Profitez de {{plan.coupon.percentOff}}% avec  le code</p>
          <UInput v-model="plan.coupon.code" required readonly class="w-64 mt-2">
            <template #trailing>
              <UButton
                  color="neutral"
                  variant="link"
                  :padded="false"
                  icon="i-ph-copy-duotone"
                  @click="copy(plan.coupon.code)"
              />
            </template>
          </UInput>
          <p class="mt-1 text-xs text-center">Dans la limite des codes disponibles,<br>valable pour un an d'abonnement</p>
        </div>
      </template>
    </UPricingPlan>
  </UPricingPlans>
  <UModal fullscreen title="Comparatif des offres">
    <div class="text-center">
      <UButton variant="ghost">Comparatif des offres</UButton>
    </div>

    <template #body>
      <UPricingTable :tiers="subscription?.table.tiers" :sections="subscription?.table.sections" />
    </template>
  </UModal>
</template>